/**
 * Orchids Lux Home — Custom Nav Bar JS
 * File: assets/orchids-nav.js
 * Handles: sticky behaviour + dropdown positioning when sticky
 */

(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {

    const wrapper     = document.getElementById('olh-nav-wrapper');
    const placeholder = document.getElementById('olh-nav-placeholder');
    if (!wrapper || !placeholder) return;

    /* ── 1. STICKY LOGIC ─────────────────────────────────── */
    let isSticky    = false;
    let originalTop = 0;

    function calcOriginalTop() {
      // Measure from placeholder when sticky, wrapper when not
      const el = isSticky ? placeholder : wrapper;
      return el.getBoundingClientRect().top + window.scrollY;
    }

    function makeSticky() {
      placeholder.style.height = wrapper.offsetHeight + 'px';
      placeholder.classList.add('is-active');
      wrapper.classList.add('is-sticky');
      isSticky = true;
      repositionAllDropdowns();
    }

    function unstick() {
      wrapper.classList.remove('is-sticky');
      placeholder.classList.remove('is-active');
      placeholder.style.height = '0';
      isSticky = false;
      // Reset any JS-positioned dropdowns
      document.querySelectorAll('.olh-nav__dropdown, .olh-nav__subdropdown').forEach(function (d) {
        d.style.top  = '';
        d.style.left = '';
      });
    }

    function onScroll() {
      if (!isSticky) originalTop = calcOriginalTop();

      if (window.scrollY > originalTop && !isSticky) {
        makeSticky();
      } else if (window.scrollY <= originalTop && isSticky) {
        unstick();
      }
    }

    // Set initial originalTop after fonts/images load
    window.addEventListener('load', function () {
      originalTop = calcOriginalTop();
    });

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () {
      if (isSticky) unstick();
      originalTop = calcOriginalTop();
    });


    /* ── 2. DROPDOWN POSITION FIX (when sticky) ─────────── */
    // When wrapper is position:fixed, CSS `top:100%` on dropdowns
    // is relative to the fixed wrapper — we override with JS coords.

    function positionDropdown(dropdown, anchorRect) {
      dropdown.style.top  = anchorRect.bottom + 'px';
      dropdown.style.left = anchorRect.left + 'px';
    }

    function positionSubdropdown(subdropdown, anchorRect) {
      subdropdown.style.top  = anchorRect.top + 'px';
      subdropdown.style.left = anchorRect.right + 'px';
    }

    function repositionAllDropdowns() {
      // Called when sticky activates — pre-position any open dropdowns
      document.querySelectorAll('.olh-nav__item--has-children:hover > .olh-nav__dropdown').forEach(function (d) {
        const li = d.closest('.olh-nav__item');
        if (li) positionDropdown(d, li.getBoundingClientRect());
      });
    }

    // Live positioning on mouseover
    wrapper.addEventListener('mouseover', function (e) {
      if (!isSticky) return;

      // Top-level dropdown
      const topItem = e.target.closest('.olh-nav__list > .olh-nav__item--has-children');
      if (topItem) {
        const dropdown = topItem.querySelector(':scope > .olh-nav__dropdown');
        if (dropdown) positionDropdown(dropdown, topItem.getBoundingClientRect());
      }

      // Sub-dropdown (3rd level)
      const subItem = e.target.closest('.olh-nav__dropdown-item--has-children');
      if (subItem) {
        const subdropdown = subItem.querySelector(':scope > .olh-nav__subdropdown');
        if (subdropdown) positionSubdropdown(subdropdown, subItem.getBoundingClientRect());
      }
    });

  });

})();
